module.exports = __webpack_public_path__ + "img/pic_guih.3d369b44.png";